import { render, staticRenderFns } from "./kpiObjectiveSpan.vue?vue&type=template&id=80b37780"
import script from "./kpiObjectiveSpan.vue?vue&type=script&lang=js"
export * from "./kpiObjectiveSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports